export default __webpack_public_path__ + "static/SRI 4410PW - Product Specifications & Technical Data-bbb27ef9796928fb6428fa7d1f47fc2c.pdf";